/*****************
 2019-3-5, AJK, updated to use Snotify
******************/

/*global localStorage*/

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Snotify from 'vue-snotify'
import './assets/css/index.css'
// import 'vue-snotify/styles/material.css'


//---------SETUP NOTIFICATIONS------------//
Vue.use(Snotify);


//---------AXIOS Setup------------//
if( localStorage.sessionId == undefined){
  localStorage.sessionId = Math.random().toString(36).substring(2);
}
var sessionId = localStorage.sessionId;
// axios.defaults.baseURL = "https://parish-client-portal-dbservices.c9users.io/api/v1/";
// axios.defaults.baseURL = window.location.protocol + "//" + window.location.hostname + '/api/v1/';
if(window.location.hostname == 'localhost'){
  axios.defaults.baseURL = 'http://localhost:8888/deans-beans/api/v1/'
}
else{
  axios.defaults.baseURL = window.location.protocol + "//" + window.location.hostname + '/api/v1/';
}

axios.defaults.headers.common['Session-Id'] = sessionId ;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.patch['Content-Type'] = 'application/json'

import Buefy from 'buefy'
Vue.use(Buefy, {
    defaultIconPack: 'fa',
    defaultDateFormatter: function(date) {
        return date.toLocaleDateString()
    }
})

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



